import React from "react";
import Hero from "@/components/Hero";
import QuickBookBar from "@/components/QuickBookBar";
import TrustSection from "@/components/TrustSection";
import ToursGrid from "@/components/ToursGrid";
import TestimonialsSection from "@/components/TestimonialsSection";
import PreFooterCTA from "@/components/PreFooterCTA";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <QuickBookBar />
      <ToursGrid />
      <TrustSection />
      <TestimonialsSection />
      <PreFooterCTA />
    </div>
  );
}
